'use client';
import React, { useState, useEffect, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
// import Button from "@mui/material/Button";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import * as _ from 'lodash';
import Cookies from 'js-cookie';
import {
  MagnifyingGlassIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowsUpDownIcon,
  ArrowTopRightOnSquareIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DeleteIcon,
} from '@heroicons/react/24/outline';
import mqtt from 'mqtt';
import { useUserContext } from '../contexts/UserContext';

let signalstopic = 'goldensparrowcapital-signals';

const PreWatchersComponent = props => {
  const {
    user
  } = useUserContext();
  const [preWatchers, setPreWatchers] = useState([])
  const [section, setSection] = useState('Active');
  const [client, setClient] = useState(null);
  const mqttClientRef = useRef(null); // this will prevent receving the subscribed message multiple times
  const wsRefBinance = useRef(null);
  const [lastUpdated, setLastUpdated] = useState(new Date().valueOf());
  const [popupPreWatcher, setPopupPreWatcher] = useState(null);
  const [fvgLow, setFvgLow] = useState({}); // { [uuid]: value }
  const [fvgHigh, setFvgHigh] = useState({}); // { [uuid]: value }

  //connect and subscribe to MQTT broker
  const _connectMQTT = async props => {
    let now = new Date().valueOf();
    if (!client) {
      let clientID = 'GoldenSparrowCapital-' + Math.random().toString(16).substring(2, 8);
      const gsccookie = Cookies.get('gsccookie') || null;
      const newClient = mqtt.connect(process.env.REACT_APP_EXTERNAL_MQTT_SERVER_URL, {
        clientId: clientID,
        username: 'user-jwt',
        password: gsccookie,
        clean: true,
        rejectUnauthorized: true,
        reconnectPeriod: 60000,
      });
      mqttClientRef.current = newClient;
      newClient.on('connect', async () => {
        console.log('Connected to MQTT:', new Date().toLocaleTimeString());

        newClient.publish('GET_PREWATCHERS', JSON.stringify({ token: gsccookie }), err => {
          if (!err) {
            // console.log('GET_PREWATCHERS request published:', new Date().toLocaleTimeString());
          } else {
            console.error('Topic Publish error', err);
          }
        });

        newClient.subscribe('RECEIVE_PREWATCHERS_WEB', err => {
          if (!err) {
            // console.log('Topic subscribed:RECEIVE_PREWATCHERS');
          } else {
            console.error('Topic Subscribe error', err);
          }
        });
      });

      setClient(newClient);
    }
  };
  useEffect(() => {
    async function fetchData() {
      if (client && user.userType == "ADMIN") {
        client.on('message', (topic, message) => {
          console.log('Received topic:', topic, new Date().toLocaleTimeString());
          if (topic == 'RECEIVE_PREWATCHERS_WEB') {
            let raw = JSON.parse(message);
            // console.log("Raw:", raw)
            setPreWatchers(raw.preWatchers);
            setLastUpdated(new Date().valueOf());
          }
        });
      }
    }
    fetchData();
    return () => {
      if (client) {
        if (mqttClientRef.current) {
          console.log('Disconnecting...', new Date().toLocaleTimeString());
          mqttClientRef.current.end(); // Disconnect properly
          setClient(null);
        }
      }
    };
  }, [client]);

  useEffect(() => {
    async function fetchData() {
      if (user.userType == "ADMIN") {
        await _connectMQTT(props);
      }
    }
    fetchData();
  }, []);

  async function handleDelete(uuid) {
    // console.log("Deleting PreWatcher:", uuid)
    const gsccookie = Cookies.get('gsccookie') || null;
    console.log("Deleting PreWatcher:", uuid, gsccookie)

    client.publish("DELETE_PREWATCHER", JSON.stringify({ token: gsccookie, uuid }), err => {
      // if (!err) {
      //   setIsProcessing(true)
      //   console.log('GET_WATCHERS request published:', new Date().toLocaleTimeString());
      // } else {
      //   console.error('Topic Publish error', err);
      // }
    });
  }



  return preWatchers ? (
    <div style={{ borderRadius: 8, width: 'auto' }}>
      <PreWatcherPopup
        preWatcher={popupPreWatcher}
        onClose={() => {
          setPopupPreWatcher(null);
        }}
        // onUpdatePreWatcher={updatedPreWatcher => {
        //   setPopupPreWatcher(updatedPreWatcher);
        //   setPreWatchers(arr => arr.map(obj => (obj.uuid === updatedPreWatcher.uuid ? updatedPreWatcher : obj)));
        // }}
        transitionPreWatcherToWatcher={object => {

          const gsccookie = Cookies.get('gsccookie') || null;
          client.publish('TRANSITION_PREWATCHER_TO_WATCHER', JSON.stringify({ token: gsccookie, preWatcher: object.preWatcher, limitPrice: object.limitPrice, stopLossPrice: object.stopLossPrice, currentPrice: object.symbolCurrentPrice }), err => {
            if (!err) {
              setPopupPreWatcher(null);
            } else {
              console.error('TRANSITION_PREWATCHER_TO_WATCHER Error:', err);
              alert("Error: Transitioning to Watcher")
            }
          });
        }}
      />
      {/* <h6 style={{ margin: 3, textAlign : "right", fontSize : 12 }}>Count: {watchers.length}</h6> */}
      {/* <h1 className="text-sm font-normal">{props.user.email + ',' + props.user.userType}</h1> */}
      <h1 className="text-xs" style={{ margin: 0, paddingTop: 1, color: 'gray', marginBottom: 3 }}>
        {' '}
        Last Updated: {new Date(lastUpdated).toLocaleDateString()} ,{' '}
        {new Date(lastUpdated).toLocaleTimeString()}
      </h1>

      {/* VALID-LOWEST-1h-LONG */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-2" style={{ marginBottom: 10 }}>
        <h1 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", }}>
          VALID-LOWEST-1h-LONG ({preWatchers.filter(preWatcher => preWatcher.strategyName === "VALID-LOWEST-1h-LONG").length})
        </h1>

        {/* Stage5 */}
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "normal", marginTop: 5 }}>
          Stage5 ({preWatchers.filter(preWatcher => preWatcher.strategyName === "VALID-LOWEST-1h-LONG" && preWatcher?.preWatcherStatus?.stage == "STAGE5").length})
        </h3>
        {preWatchers.filter(preWatcher => preWatcher.strategyName === "VALID-LOWEST-1h-LONG" && preWatcher?.preWatcherStatus?.stage == "STAGE5").length > 0 ? (
          <div style={{ padding: 5 }}>
            <table className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
              <thead>
                <tr>
                  <th className="text-sm py-2 px-4 border-b">S.No.</th>
                  <th className="text-sm py-2 px-4 border-b">Updated Date & Time</th>
                  <th className="text-sm py-2 px-4 border-b">Symbol</th>
                  <th className="text-sm py-2 px-4 border-b">Lowest Price</th>
                  <th className="text-sm py-2 px-4 border-b">Highest Price</th>
                  <th className="text-sm py-2 px-4 border-b">Delete</th>
                </tr>
              </thead>
              <tbody>
                {_.orderBy(
                  preWatchers.filter(
                    preWatcher => preWatcher.strategyName === "VALID-LOWEST-1h-LONG" &&
                      preWatcher?.preWatcherStatus?.stage == "STAGE5"
                  ),
                  'preWatcherStatus.lastUpdated',
                  'desc'
                ).map((preWatcher, index) => {
                  return (
                    <tr key={preWatcher.uuid}>
                      <td className="text-xs py-2 px-4 border-b text-center">
                        {index + 1}.
                      </td>
                      <td className="py-2 px-4 border-b text-center">
                        {new Date(preWatcher.preWatcherStatus.lastUpdated).toLocaleDateString()} {new Date(preWatcher.preWatcherStatus.lastUpdated).toLocaleTimeString()}
                      </td>
                      <td className="py-2 px-4 border-b text-center">
                        <button
                          key={index}
                          style={{
                            backgroundColor: 'grey',
                            fontSize: 12,
                            borderRadius: 5,
                            padding: 5,
                            margin: 2
                          }}
                          onClick={() =>
                            window.open(
                              'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + preWatcher.symbol,
                              '_blank'
                            )
                          }
                        >
                          <div style={{ alignItems: 'center', display: 'flex' }}>
                            <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{preWatcher.symbol} ({new Date(preWatcher.creationDate).toLocaleDateString()} {new Date(preWatcher.creationDate).toLocaleTimeString()})</h4>
                          </div>
                        </button>
                      </td>
                      <td className="py-2 px-4 border-b text-center text-sm">{preWatcher.preWatcherStatus.lowestPrice}</td>
                      <td className="py-2 px-4 border-b text-center text-sm">{preWatcher.preWatcherStatus.highestPrice}</td>
                      <td className="text-center border-b">
                        <button
                          style={{ backgroundColor: "red", borderRadius: 5, padding: 5, fontSize: 12 }}
                          onClick={() => handleDelete(preWatcher.uuid)}
                          className="text-white-500 hover:text-white-800"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

          </div>
        ) : (
          null
        )}

        {/* Stage4 */}
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "normal", marginTop: 5 }}>
          Stage4 ({preWatchers.filter(preWatcher => preWatcher.strategyName === "VALID-LOWEST-1h-LONG" && preWatcher?.preWatcherStatus?.stage == "STAGE4").length})
        </h3>
        {preWatchers.filter(preWatcher => preWatcher.strategyName === "VALID-LOWEST-1h-LONG" && preWatcher?.preWatcherStatus?.stage == "STAGE4").length > 0 ? (
          <div style={{ padding: 5 }}>
            <table className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
              <thead>
                <tr>
                  <th className="text-sm py-2 px-4 border-b">S.No.</th>
                  <th className="text-sm py-2 px-4 border-b">Updated Date & Time</th>
                  <th className="text-sm py-2 px-4 border-b">Symbol</th>
                  <th className="text-sm py-2 px-4 border-b">Lowest Price</th>
                  <th className="text-sm py-2 px-4 border-b">Highest Price</th>
                  <th className="text-sm py-2 px-4 border-b">Delete</th>
                </tr>
              </thead>
              <tbody>
                {_.orderBy(
                  preWatchers.filter(
                    preWatcher => preWatcher.strategyName === "VALID-LOWEST-1h-LONG" &&
                      preWatcher?.preWatcherStatus?.stage == "STAGE4"
                  ),
                  'preWatcherStatus.lastUpdated',
                  'desc'
                ).map((preWatcher, index) => {
                  return (
                    <tr key={preWatcher.uuid}>
                      <td className="text-xs py-2 px-4 border-b text-center">
                        {index + 1}.
                      </td>
                      <td className="py-2 px-4 border-b text-center">
                        {new Date(preWatcher.preWatcherStatus.lastUpdated).toLocaleDateString()} {new Date(preWatcher.preWatcherStatus.lastUpdated).toLocaleTimeString()}
                      </td>
                      <td className="py-2 px-4 border-b text-center">
                        <button
                          key={index}
                          style={{
                            backgroundColor: 'grey',
                            fontSize: 12,
                            borderRadius: 5,
                            padding: 5,
                            margin: 2
                          }}
                          onClick={() =>
                            window.open(
                              'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + preWatcher.symbol,
                              '_blank'
                            )
                          }
                        >
                          <div style={{ alignItems: 'center', display: 'flex' }}>
                            <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{preWatcher.symbol} ({new Date(preWatcher.creationDate).toLocaleDateString()} {new Date(preWatcher.creationDate).toLocaleTimeString()})</h4>
                          </div>
                        </button>
                      </td>
                      <td className="py-2 px-4 border-b text-center text-sm">{preWatcher.preWatcherStatus.lowestPrice}</td>
                      <td className="py-2 px-4 border-b text-center text-sm">{preWatcher.preWatcherStatus.highestPrice}</td>
                      <td className="text-center border-b">
                        <button
                          style={{ backgroundColor: "red", borderRadius: 5, padding: 5, fontSize: 12 }}
                          onClick={() => handleDelete(preWatcher.uuid)}
                          className="text-white-500 hover:text-white-800"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

          </div>
        ) : (
          null
        )}

        {/* Stage3 */}
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "normal", marginTop: 5 }}>
          Stage3 ({preWatchers.filter(preWatcher => preWatcher.strategyName === "VALID-LOWEST-1h-LONG" && preWatcher?.preWatcherStatus?.stage == "STAGE3").length})
        </h3>
        {preWatchers.filter(preWatcher => preWatcher.strategyName === "VALID-LOWEST-1h-LONG" && preWatcher?.preWatcherStatus?.stage == "STAGE3").length > 0 ? (
          <div style={{ padding: 5 }}>
            <table className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
              <thead>
                <tr>
                  <th className="text-sm py-2 px-4 border-b">S.No.</th>
                  <th className="text-sm py-2 px-4 border-b">Updated Date & Time</th>
                  <th className="text-sm py-2 px-4 border-b">Symbol</th>
                  <th className="text-sm py-2 px-4 border-b">Lowest Price</th>
                  <th className="text-sm py-2 px-4 border-b">Highest Price</th>
                  <th className="text-sm py-2 px-4 border-b">Delete</th>
                </tr>
              </thead>
              <tbody>
                {_.orderBy(
                  preWatchers.filter(
                    preWatcher => preWatcher.strategyName === "VALID-LOWEST-1h-LONG" &&
                      preWatcher?.preWatcherStatus?.stage == "STAGE3"
                  ),
                  'preWatcherStatus.lastUpdated',
                  'desc'
                ).map((preWatcher, index) => {
                  return (
                    <tr key={preWatcher.uuid}>
                      <td className="text-xs py-2 px-4 border-b text-center">
                        {index + 1}.
                      </td>
                      <td className="py-2 px-4 border-b text-center">
                        {new Date(preWatcher.preWatcherStatus.lastUpdated).toLocaleDateString()} {new Date(preWatcher.preWatcherStatus.lastUpdated).toLocaleTimeString()}
                      </td>
                      <td className="py-2 px-4 border-b text-center">
                        <button
                          key={index}
                          style={{
                            backgroundColor: 'grey',
                            fontSize: 12,
                            borderRadius: 5,
                            padding: 5,
                            margin: 2
                          }}
                          onClick={() =>
                            window.open(
                              'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + preWatcher.symbol,
                              '_blank'
                            )
                          }
                        >
                          <div style={{ alignItems: 'center', display: 'flex' }}>
                            <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{preWatcher.symbol} ({new Date(preWatcher.creationDate).toLocaleDateString()} {new Date(preWatcher.creationDate).toLocaleTimeString()})</h4>
                          </div>
                        </button>
                      </td>
                      <td className="py-2 px-4 border-b text-center text-sm">{preWatcher.preWatcherStatus.lowestPrice}</td>
                      <td className="py-2 px-4 border-b text-center text-sm">{preWatcher.preWatcherStatus.highestPrice}</td>
                      <td className="text-center border-b">
                        <button
                          style={{ backgroundColor: "red", borderRadius: 5, padding: 5, fontSize: 12 }}
                          onClick={() => handleDelete(preWatcher.uuid)}
                          className="text-white-500 hover:text-white-800"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

          </div>
        ) : (
          null
        )}

        {/* Stage1 */}
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "normal", marginTop: 5 }}>
          Stage1 ({preWatchers.filter(preWatcher => preWatcher.strategyName === "VALID-LOWEST-1h-LONG" && preWatcher?.preWatcherStatus?.stage == "STAGE1").length})
        </h3>
        {preWatchers.filter(preWatcher => preWatcher.strategyName === "VALID-LOWEST-1h-LONG" && preWatcher?.preWatcherStatus?.stage == "STAGE1").length > 0 ? (
          <div style={{ padding: 5 }}>
            {_.orderBy(
              preWatchers.filter(
                preWatcher => preWatcher.strategyName === "VALID-LOWEST-1h-LONG" &&
                  preWatcher?.preWatcherStatus?.stage == "STAGE1"
              ),
              'preWatcherStatus.lastUpdated',
              'desc'
            ).map((preWatcher, index) => {
              return (
                <button
                  key={index}
                  style={{
                    backgroundColor: 'grey',
                    fontSize: 12,
                    borderRadius: 5,
                    padding: 5,
                    margin: 2
                  }}
                  onClick={() =>
                    window.open(
                      'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + preWatcher.symbol,
                      '_blank'
                    )
                  }
                >
                  <div style={{ alignItems: 'center', display: 'flex' }}>
                    <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{preWatcher.symbol} (LowestPrice: {preWatcher.preWatcherStatus.lowestPrice}) (HighestPrice: {preWatcher.preWatcherStatus.highestPrice}) ({new Date(preWatcher.creationDate).toLocaleDateString()} {new Date(preWatcher.creationDate).toLocaleTimeString()})</h4>
                  </div>
                </button>
              );
            })}
          </div>
        ) : (
          null
        )}

        {/* Stage2 */}
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "normal", marginTop: 5 }}>
          Stage2 ({preWatchers.filter(preWatcher => preWatcher.strategyName === "VALID-LOWEST-1h-LONG" && preWatcher?.preWatcherStatus?.stage == "STAGE2").length})
        </h3>
        {preWatchers.filter(preWatcher => preWatcher.strategyName === "VALID-LOWEST-1h-LONG" && preWatcher?.preWatcherStatus?.stage == "STAGE2").length > 0 ? (
          <div style={{ padding: 5 }}>
            {_.orderBy(
              preWatchers.filter(
                preWatcher => preWatcher.strategyName === "VALID-LOWEST-1h-LONG" &&
                  preWatcher?.preWatcherStatus?.stage == "STAGE2"
              ),
              'preWatcherStatus.lastUpdated',
              'desc'
            ).map((preWatcher, index) => {
              return (
                <button
                  key={index}
                  style={{
                    backgroundColor: 'grey',
                    fontSize: 12,
                    borderRadius: 5,
                    padding: 5,
                    margin: 2
                  }}
                  onClick={() =>
                    window.open(
                      'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + preWatcher.symbol,
                      '_blank'
                    )
                  }
                >
                  <div style={{ alignItems: 'center', display: 'flex' }}>
                    <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{preWatcher.symbol} (LowestPrice: {preWatcher.preWatcherStatus.lowestPrice}) (HighestPrice: {preWatcher.preWatcherStatus.highestPrice}) ({new Date(preWatcher.creationDate).toLocaleDateString()} {new Date(preWatcher.creationDate).toLocaleTimeString()})</h4>
                  </div>
                </button>
              );
            })}
          </div>
        ) : (
          null
        )}



      </div>

    </div>
  ) : null;
};

function PreWatcherPopup({ preWatcher, onClose, transitionPreWatcherToWatcher }) {
  const wsRefBinance = useRef(null);
  const [limitPrice, setLimitPrice] = useState(null)
  const [stopLossPrice, setStopLossPrice] = useState(null)
  const [symbolCurrentPrice, setSymbolCurrentPrice] = useState(null)
  useEffect(() => {
    if (preWatcher && preWatcher.currentPrice) {
      setLimitPrice(Number(preWatcher.currentPrice).toFixed(preWatcher.numberOfDecimalValues));
      setStopLossPrice(Number(preWatcher.preWatcherStatus.lowestPrice).toFixed(preWatcher.numberOfDecimalValues));
      subscribeToSymbols([preWatcher.symbol]);
    }
  }, [preWatcher]);

  // Function to subscribe to real-time Binance prices
  const subscribeToSymbols = async (symbols) => {
    console.log("Subscribing to Binance prices for:", symbols.length);
    unsubscribeFromSymbols();
    const streams = symbols.map(symbol => `${symbol.toLowerCase()}@ticker`).join('/');
    const url = `wss://stream.binance.com:9443/stream?streams=${streams}`;

    wsRefBinance.current = new WebSocket(url);

    wsRefBinance.current.onmessage = event => {
      const message = JSON.parse(event.data);
      const { s: symbol, c: currentPrice } = message.data;
      //  console.log(`Real-time price update for ${symbol}: ${currentPrice}`);
      setSymbolCurrentPrice(currentPrice)
    };

    wsRefBinance.current.onerror = err => {
      // console.error("Binance WebSocket error:", err);
    };

    wsRefBinance.current.onclose = () => {
      // console.log("Binance WebSocket closed");
    };
  };

  // Function to unsubscribe/cleanup
  const unsubscribeFromSymbols = () => {
    if (wsRefBinance.current) {
      wsRefBinance.current.close();
      wsRefBinance.current = null;
      // console.log('Unsubscribed from Binance prices');
    }
  };

  if (!preWatcher) return null;
  return (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'stretch',
      }}
      onClick={onClose}
    >
      <div
        id="preWatcher-popoup"
        style={{
          width: '450px',
          backgroundColor: '#fff',
          padding: 24,
          borderRadius: 16,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
          paddingRight: 10,
        }}
        onClick={e => e.stopPropagation()}
      >

        {/* 1st row */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 8,
          }}
        >
          <h1 style={{ color: "blue", fontWeight: "bold" }}>{preWatcher.symbol}
            ({Number(symbolCurrentPrice).toFixed(preWatcher.numberOfDecimalValues)})
          </h1>
          <button
            style={{
              padding: '4px',
              borderWidth: 1,
              borderColor: "red",
              color: 'red',
              borderRadius: 6,
              fontSize: 11,
              cursor: 'pointer',
            }}
            onClick={() => {
              unsubscribeFromSymbols()
              onClose()
            }}
          >
            Close
          </button>
        </div>
        <hr></hr>

        {symbolCurrentPrice ?
          <>
            {/* 2nd Row */}
            <div
              style={{
                display: 'flex',
                // justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 8,
                marginTop: 30,
                gap: 20
              }}
            >
              <h1 style={{ color: '#282828', fontWeight: "bold", fontStyle: "italic", fontSize: 13 }}>Set Limit Price:</h1>
              <button
                style={{
                  padding: 3,
                  backgroundColor: 'red',
                  color: '#fff',
                  borderRadius: 50,
                  fontSize: 18,
                  cursor: 'pointer',
                  width: 35,
                  height: 35
                }}
                onClick={() => {

                  let ll = limitPrice
                  setLimitPrice(Number(Number(ll).toFixed(preWatcher.numberOfDecimalValues) - (1 / Math.pow(10, preWatcher.numberOfDecimalValues))).toFixed(preWatcher.numberOfDecimalValues))

                  let sl = stopLossPrice
                  if (Number(sl) >= Number(limitPrice)) {
                    setStopLossPrice(Number(Number(ll).toFixed(preWatcher.numberOfDecimalValues) - (2 / Math.pow(10, preWatcher.numberOfDecimalValues))).toFixed(preWatcher.numberOfDecimalValues))
                  }

                }}
              >
                -
              </button>
              <h1 style={{ color: '#282828', fontWeight: 'bold' }}>{limitPrice}</h1>

              <button
                style={{
                  padding: 3,
                  backgroundColor: 'green',
                  color: '#fff',
                  borderRadius: 50,
                  fontSize: 18,
                  cursor: 'pointer',
                  width: 35,
                  height: 35

                }}
                onClick={() => {

                  let ll = limitPrice
                  setLimitPrice(Number(Number(ll).toFixed(preWatcher.numberOfDecimalValues) + (1 / Math.pow(10, preWatcher.numberOfDecimalValues))).toFixed(preWatcher.numberOfDecimalValues))
                }}
              >
                +
              </button>





            </div>

            {/* 3rd Row */}
            <div
              style={{
                display: 'flex',
                // justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 8,
                marginTop: 30,
                gap: 20
              }}
            >
              <h1 style={{ color: '#282828', fontWeight: "bold", fontStyle: "italic", fontSize: 13 }}>Set Stop Loss Price:</h1>
              <button
                style={{
                  padding: 3,
                  backgroundColor: 'red',
                  color: '#fff',
                  borderRadius: 50,
                  fontSize: 18,
                  cursor: 'pointer',
                  width: 35,
                  height: 35
                }}
                onClick={() => {
                  let ll = stopLossPrice
                  setStopLossPrice(Number(Number(ll).toFixed(preWatcher.numberOfDecimalValues) - (1 / Math.pow(10, preWatcher.numberOfDecimalValues))).toFixed(preWatcher.numberOfDecimalValues))
                }}
              >
                -
              </button>
              <h1 style={{ color: '#282828', fontWeight: 'bold' }}>{stopLossPrice}</h1>

              <button
                style={{
                  padding: 3,
                  backgroundColor: 'green',
                  color: '#fff',
                  borderRadius: 50,
                  fontSize: 18,
                  cursor: 'pointer',
                  width: 35,
                  height: 35

                }}
                onClick={() => {
                  let ll = stopLossPrice
                  setStopLossPrice(Number(Number(ll).toFixed(preWatcher.numberOfDecimalValues) + (1 / Math.pow(10, preWatcher.numberOfDecimalValues))).toFixed(preWatcher.numberOfDecimalValues))
                }}
              >
                +
              </button>
            </div>

            {/* 4th row */}
            <div
              style={{
                display: 'flex',
                marginBottom: 8,
                justifyContent: "center",
                columnGap: 5
              }}
            >
              <button
                style={{
                  padding: '5px',
                  borderWidth: 1,
                  borderColor: "blue",
                  color: 'blue',
                  borderRadius: 6,

                  cursor: 'pointer',
                  marginTop: 30,
                  fontSize: 14,


                }}
                onClick={() => {
                  transitionPreWatcherToWatcher({ preWatcher, limitPrice, stopLossPrice, symbolCurrentPrice })
                }}
              >
                Add to Watcher
              </button>


            </div>
          </>
          : null}
      </div>
    </div>
  );
}

export default PreWatchersComponent;
